import { useThemeStore } from "@stores/theme.store";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Slider1 from "@assets/images/slider-1.jpeg";
import { Button } from "antd";
import moment from "moment";

export const MadingDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [ellipsisText, setEllipsisText] = useState<boolean>(true);
  const text = ``;

  useEffect(() => {
    window.scrollTo(0, 0);
    setAppBar({ title: "Informasi SIPiat", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Informasi SIPiat",
    });
  }, [setHeader, setAppBar]);

  return (
    <div className="tw-px-4 tw-pb-10">
      <div className="tw-bg-other-100 tw-rounded-lg tw-p-4">
        <div className="tw-text-base tw-font-bold tw-mb-2 tw-text-other-700">
          <div className="tw-block tw-text-xs tw-font-light tw-text-other-600">
            {moment(state.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
          </div>
        </div>
        <img
          className="tw-w-full tw-h-full tw-rounded-md tw-object-cover"
          src={state.gambar}
          alt=""
        />
        <div className="tw-my-4 tw-text-base tw-text-black tw-font-semibold">
          {state.judul}
        </div>
        <pre
          className="tw-mb-6 tw-text-sm tw-font-medium tw-text-other-700"
          style={{
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            overflow: "auto",
            letterSpacing: "1.3px",
          }}
        >
          {/* {text.length > 200 ? (
            <>
              {text.substring(0, 200)}
              <span className="dots">{ellipsisText ? "..." : ""}</span>
              <span
                className="more-content"
                style={{
                  display: ellipsisText ? "none" : "inline",
                }}
              >
                {text.substring(200, text.length)}
              </span>
              <div
                className="tw-text-[13px] tw-text-other-600 tw-text-right"
                onClick={() => setEllipsisText(!ellipsisText)}
              >
                {ellipsisText ? "selengkapnya" : "lebih sedikit"}
              </div>
            </>
          ) : (
            text
          )} */}
          {state.pesan}
        </pre>
      </div>
    </div>
  );
};
